import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1807.059 1637.706c0 31.172-25.412 56.47-56.47 56.47H169.411c-31.06 0-56.47-25.298-56.47-56.47V225.94h590.907L854.4 451.824H225.882v112.94H1807.06v1072.942zM990.269 451.824L764.385 113H0v1524.706c0 93.402 76.01 169.412 169.412 169.412h1581.176c93.403 0 169.412-76.01 169.412-169.412V451.824H990.268z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFolderLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFolderLine, _Component);

  var _super = _createSuper(IconFolderLine);

  function IconFolderLine() {
    _classCallCheck(this, IconFolderLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFolderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFolder",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconFolderLine.displayName = "IconFolderLine";
  return IconFolderLine;
}(Component);

IconFolderLine.glyphName = 'folder';
IconFolderLine.variant = 'Line';
IconFolderLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFolderLine;
export { IconFolderLine };